export function wrapV7Cell(Cell: React.FC<any>): React.FC<any> {
  if (!Cell) {
    return Cell;
  }

  if ('v8' in Cell && typeof Cell.v8 === 'function') {
    return Cell.v8 as React.FC<any>;
  }

  return function V8CellWrapper(props: any) {
    return (
      <Cell
        {...props}
        value={props.getValue()}
        column={{ ...props.column, ...props.column.columnDef }}
      />
    );
  };
}
